module.exports = {
      id: "mobile-share-usage",
      viewBox: "0 0 16.211 17.807",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#mobile-share",
      toString: function () {
        return this.url;
      }
    }